import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subject } from 'rxjs';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import {
  EXTRA_BOARD_CHOICES,
  EXTRA_BOARD_CHOICES_ARRAY
} from 'src/app/model/product/ip-board/extra-board';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'ip-board-extra-board-input',
  templateUrl: './ip-board-extra-board-input.component.html',
  styleUrls: ['./ip-board-extra-board-input.component.scss']
})
export class IPBoardExtraBoardInputComponent extends SubscriptionBasedComponent
  implements OnInit, OnDestroy {
  @Input()
  ipBoard: IPBoard;

  @Output()
  save = new EventEmitter<any>();

  withExtraBoard: boolean = false;

  EXTRA_BOARD_CHOICES_ARRAY = EXTRA_BOARD_CHOICES_ARRAY;

  private emitIPBoardConfigurationChanged = new Subject<any>();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.withExtraBoard = this.ipBoard.extraBoard != null;
    this.addSubscription(
      this.emitIPBoardConfigurationChanged,
      () =>
        this.projectDisplayObservableService
          .getIPBoardConfigurationChangedSubscribable()
          .next(),
      GeneralHelper.noop,
      500
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.emitIPBoardConfigurationChanged != null) {
      this.emitIPBoardConfigurationChanged.complete();
      this.emitIPBoardConfigurationChanged = null;
    }
  }

  withExtraBoardChanged(): void {
    if (this.withExtraBoard) {
      this.ipBoard.extraBoard = EXTRA_BOARD_CHOICES.UNDER_BOARD;
    } else {
      this.ipBoard.extraBoard = null;
      this.ipBoard.extraBoardText = null;
      this.ipBoard.extraBoardColor = null;
    }
    this.projectDisplayObservableService
      .getIPBoardConfigurationChangedSubscribable()
      .next();
    this.save.emit();
  }

  extraBoardTextChanged(value: string): void {
    this.ipBoard.extraBoardText = value;
    this.emitIPBoardConfigurationChanged.next();
    this.save.emit();
  }

  extraBoardColorChanged(value: string): void {
    this.ipBoard.extraBoardColor = value;
    this.emitIPBoardConfigurationChanged.next();
    this.save.emit();
  }

  compareOrdinalEnum(e1, e2): boolean {
    return GeneralHelper.compareOrdinalEnum(e1, e2);
  }
}
